import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { mapToolChanged } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import {
  MapSettingsToolsStateActiveTool, type MapSettingsToolsStateActiveToolState,
} from './mapSettingsToolsStateActiveTool.state';

export const mapSettingsToolsStateActiveToolInitialState: MapSettingsToolsStateActiveToolState = null;

type Action = ReturnType<typeof mapToolChanged>;

export const mapSettingsToolsStateActiveToolReducer = (
  state: MapSettingsToolsStateActiveToolState = mapSettingsToolsStateActiveToolInitialState,
  action: Action,
): MapSettingsToolsStateActiveToolState => {
  // The active tool only changes when the other tool gets opened, closing a tool's panel keeps it active
  if (mapToolChanged.match(action)) {
    switch (action.payload.newTool) {
      case MapTool.Boundary:
        return MapSettingsToolsStateActiveTool.Boundary;
      case MapTool.DataLayers:
        return MapSettingsToolsStateActiveTool.DataLayers;
      default:
        return state;
    }
  }

  return state;
};
